const log = (head, value = "") => console.log(`${head}`, value);

// these properties will be available from anywhere via this.property
export const constants = {
  isDev: "ontouchstart" in window 
    ? (() => { $("html").removeClass("no-dev"); return true; })() 
    : false,
  $body: $("body"),
  $window: $(window),
  $document: $(document),
};

// these functions won't run at once, but will be available from anywhere via this.functionName
export const staticFunctions = {
  sparedFunction() {
    // console.log("spareFunction executed");
  },
  anotherSparedFunction(arg) {
    // console.log(`anotherSpareFunction executed with args: ${arg}`);
  },
};

// runs at once. runs on all pages because of bound with 'body' selector
export function commonFunction() {
  // console.log("window was loaded");
  // isTouch is available from anywhere via this.isTouch
  // console.log(`is touch: ${this.isTouch}`);
}

// runs at once. runs on all pages because of bound with 'body' selector
export function anotherCommonFunction() {
  window.addEventListener("resize", () => {
    setTimeout(() => {
      // console.log("window was resized");
    }, 500);
  });
}
// runs at once. runs on any page, where .header selector can be found


// WEBPACK FOOTER //
// ./assets/js/modules/module.js